import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import PassportPortalLogin from "./Pages/PassportPortalLogin";
import CitizenPassportForm from "./Pages/CitizenPassportForm";
import CitizenPortal from "./Pages/CitizenPortal";
import RenewalPage from "./Pages/applicationstatus/RenewalPage";
import ApplicationStatus from "./ApplicationStatus";
import StepPayment from "./components/Public/StepPayment";
import PassportApplicationCallback from "./Pages/PassportApplicationCallback";
import PassportStatusApproved from "./Pages/applicationstatus/approved";
import RejectedPage from "./Pages/applicationstatus/RejectedPage";
import StatusPending from "./Pages/applicationstatus/Pending";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  return (
    <Router>
      {/* Sri Lankan flag color strip at the very top of every page */}
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: 'clamp(6px, 1.2vw, 8px)',
        zIndex: 10000
      }}>
        <img
          src="/assets/Images/SLUDI-login-top-strip.png"
          alt="Sri Lankan flag colors"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block'
          }}
        />
      </div>
      {/* Add top padding so fixed strip never overlaps content */}
      <div className="App" style={{ paddingTop: 'clamp(6px, 1.2vw, 8px)' }}>
        <Routes>
          {/* Default route redirects to login */}
          <Route path="/" element={<Navigate to="/login" replace />} />

          {/* Public routes — no auth required */}
          <Route path="/login" element={<PassportPortalLogin />} />
          <Route path="auth/callback" element={<PassportApplicationCallback />} />

          {/* Protected citizen routes */}
          <Route
            path="/passport"
            element={<ProtectedRoute><Navigate to="/passport/application" replace /></ProtectedRoute>}
          />
          <Route
            path="/passport/application"
            element={<ProtectedRoute><CitizenPortal /></ProtectedRoute>}
          />
          <Route
            path="/apply"
            element={<ProtectedRoute><CitizenPassportForm /></ProtectedRoute>}
          />
          <Route
            path="/passport/status/renewal"
            element={<ProtectedRoute><RenewalPage /></ProtectedRoute>}
          />
          <Route
            path="/passport/status/rejected"
            element={<ProtectedRoute><RejectedPage /></ProtectedRoute>}
          />
          <Route
            path="/passport/status/pending"
            element={<ProtectedRoute><StatusPending /></ProtectedRoute>}
          />

          {/* Payment page */}
          <Route
            path="/passport/payment"
            element={<ProtectedRoute><StepPayment /></ProtectedRoute>}
          />

          {/* Status pages */}
          <Route
            path="/passport/status"
            element={<ProtectedRoute><ApplicationStatus /></ProtectedRoute>}
          />
          <Route
            path="/passport/status/pending"
            element={<ProtectedRoute><StatusPending /></ProtectedRoute>}
          />
          <Route
            path="/passport/status/approved"
            element={<ProtectedRoute><PassportStatusApproved /></ProtectedRoute>}
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
